import { render, staticRenderFns } from "./StaffAttendanceManagementModal.vue?vue&type=template&id=d97f6c62&scoped=true&"
import script from "./StaffAttendanceManagementModal.vue?vue&type=script&lang=js&"
export * from "./StaffAttendanceManagementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97f6c62",
  null
  
)

export default component.exports